<template>
  <div class="class_info_box-root">
    <div class="list-traing">
      <div class="left" v-if="showPeriod">
        <p class="period">
          <span>{{traing.class_level}}</span>
          <span>级</span>
          <span>第</span>
          <span class="vertical">{{traing.periods}}</span>
          <span>期</span>
        </p>
      </div>
      <div class="right">
        <p class="name">
          <span v-if="traing.is_special_train === 1">【快】</span>
          {{traing.name}}
        </p>
        <div class="info">
          <div class="cover">
            <img class="img" :src="isImgLoadErr ? $options._myOpt.classDefaultImg : traing.moment_picture" @error="imgLoadErr">
            <status-flag class="status-flag" :status="traing.status"></status-flag>
          </div>
          <div class="text-wrap" v-if="ifShow(traing.teacher_names)">
            <p
              class=""
            >培训日期：{{traing.start_date | time(false)}} 至 {{traing.end_date | time(false)}}</p>
            <p>培训班级别：{{traing.class_level}} 级</p>
            <p class="" v-if="ifShow(traing.teacher_names)">被调查者：{{traing.teacher_names}}</p>
          </div>
          <div class="text-wrap" v-else>
            <p
              class=""
            >培训日期：{{traing.start_date | time(false)}} 至 {{traing.end_date | time(false)}}</p>
            <p>培训班级别：{{traing.class_level}} 级 （{{traing.class_train_type | classType}}）</p>
            <p class="">主讲师：{{traing.teacher_off_name ? traing.teacher_off_name : "足协指派"}}</p>
            <p
              class=""
              v-if="ifShow(traing.teacher_name)"
            >助理讲师：{{traing.teacher_name}}</p>
<!--            <p-->
<!--              class=""-->
<!--              v-if="ifShow(traing.intern_teacher)"-->
<!--            >实习讲师：{{traing.intern_teacher}}</p>-->
            <p v-if="(traing.class_level ==='C' || traing.class_level ==='D') && ifShow(traing.intern_teacher) && traing.class_train_type === 'train'">实习讲师：{{ traing.intern_teacher }}</p>
            <p v-if="ifShow(traing.lecturer_assistant_name) && (traing.class_level ==='B' || traing.class_level ==='A' || traing.class_train_type === 'continue_education')">讲师助理：{{ traing.lecturer_assistant_name }}</p>
            <p v-if="traing.hours">学时：{{ traing.hours }}</p>
          </div>
          <slot></slot>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import classDefaultImg from "@/assets/images/class_logo.png";
import {typeFilters} from "@/assets/js/status";

export default {
  name: "ClassInfoBox",
  _myOpt: {
    classDefaultImg,
  },
  props: {
    traing: {
      type: Object,
      default() {
        return {};
      }
    },
    showPeriod: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isImgLoadErr: false,
    }
  },
  filters: {
    classType(level) {
      return typeFilters(level);
    },
  },
  methods: {
    imgLoadErr() {
      this.isImgLoadErr = true
    },
    ifShow(key) {
      return !['',null,undefined].includes(key)
    }
  },
  components: {
    "status-flag": () => import("@/components/Tips/Status"),
  }
};
</script>

<style lang="stylus">
@import '~@/assets/css/mixin'

.class_info_box-root
  display block
  .list-traing
    display flex
    .left
      border 1px solid
      margin-right 10px
      display flex
      .period
        flex 1 1 auto
        width 48px
        display flex
        flex-direction column
        justify-content center
        align-items center
    .right
      flex 1
      border 1px solid
      padding 10px
      .name
        font-size $font_size_class_name
        margin-bottom 10px
      .info
        display flex
        .cover
          position relative
          width 138px
          height 100px
          margin-right 10px
          .img
            display block
            width 100%
            height 100%
          .status-flag
            left -2px
        .text-wrap
          display flex
          flex 1
          margin-right 10px
          font-size $font_size_medium
          line-height 1
          flex-direction column
          justify-content space-around
          &>p
            margin-bottom 0.35em
        .btn-wrap
          .btn
            margin-top 15px
            padding 10px 16px
</style>


